import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';
import { useTestCountByMonthUearMutation } from '../Eyetest/eyetestApi';
import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

export function LineChart() {
    const [loading, setLoading] = useState(true);
    const [year2025Data, setYear2025Data] = useState([]);
    const [year2024Data, setYear2024Data] = useState([]);
    const [testCount] = useTestCountByMonthUearMutation();

    useEffect(() => {
        (async () => {
            if (loading) {
                let { data } = await testCount();
                console.log(data.yearData['2025'], 'resultresultresult');
                setYear2025Data(data.yearData['2025']);
                setYear2024Data(data.yearData['2024']);
                setLoading(false);
            }
        })();
    }, [loading]);

    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    const values = [380, 420, 390, 480, 450, 470];
    const thresholds = [350, 390, 410, 430, 460, 450];
    const chartData = {
        labels: months,
        datasets: [
            {
                label: 'Value',
                data: year2025Data,
                borderColor: 'black',
                backgroundColor: 'transparent',
                borderWidth: 2,
                tension: 0.4,
                pointRadius: 0,
            },
            {
                label: 'Threshold',
                data: year2024Data,
                borderColor: '#aaa',
                backgroundColor: 'transparent',
                borderWidth: 1.5,
                borderDash: [4, 4],
                tension: 0.4,
                pointRadius: 0,
            },
        ],
    };
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                ticks: {
                    color: '#666',
                    font: {
                        size: 12,
                    },
                },
            },
            y: {
                display: false,
            },
        },
        elements: {
            line: {
                cubicInterpolationMode: 'monotone',
            },
        },
    };

    return (
        <>
            {loading ? (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : (
                <Line data={chartData} options={chartOptions} />
            )}
        </>
    );
}
